import { AviaPlugin } from 'tag/ts/tag/player/adapters/avia/plugins/AviaPlugin';
export class TrackingServicePlugin extends AviaPlugin {
    package = undefined;
    namespaceKey = undefined;
    get namespaceComplete() {
        return 'vtg.ts.AviaTracking';
    }
    constructor(argument) {
        super({
            ...argument,
            name: 'TrackingServicePlugin'
        });
    }
    shouldBeUsed() {
        const utagExists = this.utils.Type.isDefined(window?.utag);
        const vtgTrackingServiceExists = this.utils.Type.isDefined(this.loadedPlugin);
        const vtgTrackingConfigExists = this.utils.Type.isDefined(window?.vtg?.config);
        const trackingDisabled = this?.params?.TAG?.trackingDisabled || false;
        return utagExists && vtgTrackingServiceExists && vtgTrackingConfigExists && trackingDisabled === false;
    }
    getFactoryParams() {
        return {
            config: window?.vtg?.config
        };
    }
}
